<template>
  <div>
    <b-img class="rounded-borders hover float-right" height="20" width="28"  @click="changeLang('de')" src="../../assets/images/de.png" alt="GER"/>
    <b-img class="rounded-borders hover float-right mr-1" height="20" width="28"  @click="changeLang('en')" src="../../assets/images/en.png" alt="EN"/>

    <span class="my-auto float-right pr-2" style="white-space: nowrap" v-if="isTestDatabaseEnabled && isTestRulesEnabled">TEST-DB / TEST-Regeln</span>
    <span class="my-auto float-right pr-2" style="white-space: nowrap" v-else-if="!isTestDatabaseEnabled && isTestRulesEnabled">PROD-DB / TEST-Regeln</span>
    <span class="my-auto float-right pr-2" style="white-space: nowrap" v-else-if="isTestDatabaseEnabled && !isTestRulesEnabled">TEST-DB / FREIGABE-Regeln</span>
  </div>
</template>

<script>

    import {v1 as uuidv1} from "uuid";

    export default {
        name: "LocaleChanger",
        methods: {
            changeLang(locale) {
                if (this.$i18n.locale !== locale) {
                  let loadingFlag = uuidv1();
                  this.$store.commit('setLoadingFlag', loadingFlag);
                    this.$i18n.locale = locale;
                    document.title = this.$i18n.t('general.title');
                    this.$store.dispatch('setProductTreeVisibility', false);
                    this.$store.dispatch('setProductBreadcrumb', '')
                    this.$store.dispatch('setDirectAccessVisibility', true);
                    if(this.$route.name.startsWith('StartPage')){
                      this.$store.dispatch('initProductTree', locale)
                      .then(response => {
                        if (response === 'success'){
                          this.$store.commit('removeLoadingFlag', loadingFlag);
                        }
                      })
                    } else {
                      this.$store.commit('removeLoadingFlag', loadingFlag);
                    }
                    this.$store.dispatch('setProductList', {})

                    if(this.$route.name.startsWith('ConfigPage')){
                      //Fire validation with new lang
                      this.$store.dispatch('validateKonfigModel')
                    }
                }
            },
        },
        mounted() {
            document.title = this.$i18n.t('general.title');
        },
        computed: {
          isTestDatabaseEnabled: function() {
            return this.$store.getters.isTestDatabaseEnabled;
        },
        isTestRulesEnabled: function() {
          return this.$store.getters.isTestRulesEnabled;
        }
      }
    }
</script>

<style scoped>
    .rounded-borders {
        border-radius: 2px;
    }

    .hover {
        cursor: pointer;
    }
    .px-custom{
      padding-right: 5px;
      padding-left: 0px;
    }
</style>